/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface ContactLieuEditDto
 */
export interface ContactLieuEditDto {
    /**
     * 
     * @type {number}
     * @memberof ContactLieuEditDto
     */
    idcontactLieu?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactLieuEditDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    remarqueLieu?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContactLieuEditDto
     */
    idcontact?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContactLieuEditDto
     */
    principal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    fonction?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContactLieuEditDto
     */
    sortieEntreprise?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ContactLieuEditDto
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    codePaysNaissance?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContactLieuEditDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    numeroIdentification?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ContactLieuEditDto
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ContactLieuEditDto
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof ContactLieuEditDto
     */
    email?: EmailDto;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactLieuEditDto
     */
    photo?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContactLieuEditDto
     */
    idfichierPhoto?: number | null;
}

/**
 * Check if a given object implements the ContactLieuEditDto interface.
 */
export function instanceOfContactLieuEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactLieuEditDtoFromJSON(json: any): ContactLieuEditDto {
    return ContactLieuEditDtoFromJSONTyped(json, false);
}

export function ContactLieuEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactLieuEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontactLieu': !exists(json, 'idcontactLieu') ? undefined : json['idcontactLieu'],
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'remarqueLieu': !exists(json, 'remarqueLieu') ? undefined : json['remarqueLieu'],
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'principal': !exists(json, 'principal') ? undefined : json['principal'],
        'fonction': !exists(json, 'fonction') ? undefined : json['fonction'],
        'sortieEntreprise': !exists(json, 'sortieEntreprise') ? undefined : (json['sortieEntreprise'] === null ? null : new Date(json['sortieEntreprise'])),
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codePaysNaissance': !exists(json, 'codePaysNaissance') ? undefined : json['codePaysNaissance'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'numeroIdentification': !exists(json, 'numeroIdentification') ? undefined : json['numeroIdentification'],
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'photo': !exists(json, 'photo') ? undefined : json['photo'],
        'idfichierPhoto': !exists(json, 'idfichierPhoto') ? undefined : json['idfichierPhoto'],
    };
}

export function ContactLieuEditDtoToJSON(value?: ContactLieuEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontactLieu': value.idcontactLieu,
        'idlieuFormation': value.idlieuFormation,
        'remarqueLieu': value.remarqueLieu,
        'idcontact': value.idcontact,
        'principal': value.principal,
        'fonction': value.fonction,
        'sortieEntreprise': value.sortieEntreprise === undefined ? undefined : (value.sortieEntreprise === null ? null : value.sortieEntreprise.toISOString()),
        'idpersonne': value.idpersonne,
        'nom': value.nom,
        'prenom': value.prenom,
        'codesexe': value.codesexe,
        'nationalite': value.nationalite,
        'codePaysNaissance': value.codePaysNaissance,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'registreNational': value.registreNational,
        'numeroIdentification': value.numeroIdentification,
        'telephone': TelephoneDtoToJSON(value.telephone),
        'gsm': TelephoneDtoToJSON(value.gsm),
        'email': EmailDtoToJSON(value.email),
        'remarque': value.remarque,
        'photo': value.photo,
        'idfichierPhoto': value.idfichierPhoto,
    };
}

